import angular from 'angular';

import maxCounter from '../maxCounter/maxCounter';

export default angular
  .module('csm.ui.charCounter', [maxCounter])

  /*****************************************************************************
   * Directive: charCounter
   *
   * @ description
   * Adds a div that contains a maxCounter element to display character counts
   * from the target element. The counter is shown when the element has focus or
   * when the mouse is over it.  Since this element creates its own child scope,
   * the ngModel should be using the parent object notation.
   *
   * Note: The element that this directive is used on cannot be an display inline
   *       or positioning will be incorrect when the content is wrapping since
   *       inline elements will have the same height even when there is content
   *       wrapping.
   *
   * @attr {string} charCounter Expression/value for the maximum characters
   * @attr {string} focusOnly   Marker attribute to display counter on focus only
   *****************************************************************************/
  /* @ngInject */
  .directive('charCounter', function ($compile, $document, $timeout) {
    /*-------------------------------------------------------*/
    /* Add style block to set up border and background color */
    /*-------------------------------------------------------*/
    var mBody = $document.find('body');
    mBody.append(
      angular.element(
        '<style>' +
          'max-counter.with-char { background-color: white; border: 1px solid; border-bottom: 0px }' +
          '</style>'
      )
    );

    return {
      restrict: 'A',
      scope: true,
      link: function (scope, element, attrs) {
        /** Element has focus indicator. */ var mHasFocus = false;
        /** Focus only behavior. */ var mFocusOnly =
          attrs.focusOnly != undefined;
        /** Container Div for the counter. */ var mContainerDiv = null;
        /** MaxCounter Element. */ var mMaxCounter = null;
        /** Display in Bottom Left. */ var mBottomRight =
          attrs.location == 'bottom-right';

        /*************************************************************************
         * hideCount */
        /**
         * Blur/mouseout event handler. Hides the container div from being
         * displayed if the element is not currently in focus.
         *
         * @param event  Event
         *************************************************************************/
        function hideCount(event) {
          if (event.type == 'blur') mHasFocus = false;

          if (!mHasFocus) mContainerDiv.css('display', 'none');
        }

        /*************************************************************************
         * positionContainer */
        /**
         * Shows the container div and positions it on top of the element.
         *************************************************************************/
        function positionContainer() {
          /*-------------------------------------*/
          /* Get element styles and client       */
          /* rectangle for cross-browser sizing. */
          /*-------------------------------------*/
          var styles = window.getComputedStyle(element[0]);
          var rect = element[0].getBoundingClientRect();

          /*-----------------------------------*/
          /* Ensure element is visible and set */
          /* width to directive element width  */
          /*-----------------------------------*/
          mContainerDiv.css('display', 'block');
          mContainerDiv.css('width', rect.right - rect.left + 'px');

          /*-----------------------------------*/
          /* Get the elements top border width */
          /*-----------------------------------*/
          var bw = Number(styles['border-top-width'].replace(/\D/g, ''));

          /*------------------------------------------------*/
          /* Position the container such that its bottom    */
          /* covers the top border of the directive element */
          /*------------------------------------------------*/
          var elemLeft = element[0].offsetLeft;
          var elemTop = element[0].offsetTop;
          var elemHeight = rect.bottom - rect.top;

          /*-------------------------------------*/
          /* Remove alpha characters from value  */
          /* as it could contain a decimal in IE */
          /*-------------------------------------*/
          var contHeight = Number(
            window
              .getComputedStyle(mContainerDiv[0])
              ['height'].replace(/[a-z]/g, '')
          );

          mContainerDiv.css(
            'top',
            (mBottomRight ? elemHeight : 0) + elemTop - contHeight + bw + 'px'
          );
          mContainerDiv.css('left', elemLeft + 'px');

          /*----------------------------------------------*/
          /* Set the border color of the maxCounter so it */
          /* blends with the directive element's border   */
          /*----------------------------------------------*/
          var bc = styles['border-top-color'];
          mMaxCounter.css('border-top-color', bc);
          mMaxCounter.css('border-left-color', bc);
          mMaxCounter.css('border-right-color', bc);
        }

        /*************************************************************************
         * showCount */
        /**
         * Focus/mouseover event handler. Shows the container div.
         *
         * @param event  Event
         *************************************************************************/
        function showCount(event) {
          var isFocusEvent = event.type == 'focus';
          if (isFocusEvent) mHasFocus = true;

          /*------------------------------*/
          /* Show if not already in focus */
          /*------------------------------*/
          if (isFocusEvent || (!mFocusOnly && !mHasFocus))
            $timeout(positionContainer);
        }

        /*--------------------------------------------------------*/
        /* Build container div to be positioned above the element */
        /*--------------------------------------------------------*/
        mContainerDiv = angular.element('<div></div>');
        mContainerDiv.css('text-align', 'right');
        mContainerDiv.css('position', 'absolute');
        mContainerDiv.css('display', 'none');

        /*--------------------------------*/
        /* Build the maxCounter directive */
        /* element to display the counts  */
        /*--------------------------------*/
        mMaxCounter = angular.element('<max-counter></max-counter>');
        mMaxCounter.addClass('with-char');
        mMaxCounter.attr('value', attrs.ngModel + '.length');
        mMaxCounter.css('display', 'inline-block');
        mContainerDiv.append($compile(mMaxCounter)(scope));

        /*-----------------------------------*/
        /* Add container to element's parent */
        /* and ensure positioning is correct */
        /*-----------------------------------*/
        var parent = element.parent();
        parent.css('position', 'relative');
        parent.append(mContainerDiv);

        /*------------------------*/
        /* Set up event listeners */
        /*------------------------*/
        element.on('focus mouseover', showCount);
        element.on('blur mouseout', hideCount);

        /*----------------------------------------*/
        /* Watch for changes for the max property */
        /*----------------------------------------*/
        scope.$watch(
          function () {
            return attrs.charCounter;
          },
          function (max) {
            mMaxCounter.attr('max', max);
          }
        );

        /*---------*/
        /* Cleanup */
        /*---------*/
        scope.$on('$destroy', function () {
          mContainerDiv.remove();
          element.off('focus mouseover', showCount);
          element.off('blur mouseout', hideCount);
        });
      }
    };
  })
  .name;
